export default __webpack_public_path__ + "static/media/usuario_enviar_reporte.0a94f8e5.svg";